module.exports = __webpack_public_path__ + "static/media/功能教学@2x.afcbd9e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/功能教学@2x.png
// module id = 1464
// module chunks = 0